import styled, { device } from "@theme/utils";

export const TeamArea = styled.div`
    padding-top: 100px;
    padding-bottom: 100px;
`;
